import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import router from '@/router'
import { useStore } from './store'
import { MenuActionType } from '@/store/modules/menu/action-types'

const whiteList = [
  '/403',
  '/login',
  '/my/login',
  '/my/register',
  '/kaka/login',
  '/kaka/register',
  '/ph/login',
  '/ph/register',
  '/th/login',
  '/th/register',
  '/xf/login',
  '/xf/register',
  '/dy/login',
  '/dy/register',
  '/poster',
  '/ind/login',
  '/ind/register',
  '/lh/login',
  '/lh/register',
  '/vi/login',
  '/vi/register',
  '/ind2/login',
  '/ind2/register',
  '/kr/login',
  '/kr/register',
  '/pak/login',
  '/pak/register',
  '/ph2/login',
  '/ph2/register',
  '/ph1/summary',
  '/br1/login',
  '/br1/register',
  '/br2/login',
  '/br2/register',
  '/lk6/login',
  '/lk6/register',
  '/ak2/login',
  '/ak2/register',
  '/mx4/login'
]
NProgress.configure({ showSpinner: false })

router.beforeEach(async (to, _, next) => {
  NProgress.start()
  const store = useStore()
  // Determine whether the user has logged in, if logged in can visit any page
  if (store.state.user.token) {
    if (!store.state.menu.routesLoaded) {
      await store.dispatch(MenuActionType.ACTION_SET_ROUTES, undefined)
    }
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      next()
    }
  } else {
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // In the free login whitelist, go directly
      next()
    } else {
      const currentHost = window.location.hostname
      const siteCode = currentHost.substring(0, 3)
      const thaiHost = 'affiliate-web.monemental.com'
      const ph1Host = 'ph1-os.dt2e7svs94.com'
      const lk6Host = '6666vip.cc'

      console.log("Hostname: " + window.location.hostname)

      if (currentHost === thaiHost) {
        next(`/th/login?redirect=${to.path}`)
      } else if (currentHost === ph1Host) {
        next(`/ph1/summary`)
      } else if (currentHost === lk6Host) {
        next(`/lk6/login?redirect=${to.path}`)
      } else {
        console.log('IS Check')
        console.log(siteCode)
        if (siteCode === 'lh1') {
          next(`/lh/login?redirect=${to.path}`)
        } else if (siteCode === 'dy2') {
          next(`/dy/login?redirect=${to.path}`)
        } else if (siteCode === 'xf1') {
          next(`/xf/login?redirect=${to.path}`)
        } else if (siteCode === 'iw2') {
          next(`/ind2/login?redirect=${to.path}`)
        } else if (siteCode === 'ind') {
          next(`/ind/login?redirect=${to.path}`)
        } else if (siteCode === 'vnm') {
          next(`/vi/login?redirect=${to.path}`)
        } else if (siteCode === 'ka1' || siteCode === 'ka2') {
          next(`/kaka/login?redirect=${to.path}`)
        } else if (siteCode === 'krw') {
          next(`/kr/login?redirect=${to.path}`)
        } else if (siteCode === 'pak') {
          next(`/pak/login?redirect=${to.path}`)
        } else if (siteCode === 'ph2') {
          next(`/ph2/login?redirect=${to.path}`)
        } else if (siteCode === 'br1') {
          next(`/br1/login?redirect=${to.path}`)
        } else if (siteCode === 'br2') {
          next(`/br2/login?redirect=${to.path}`)
        } else if (siteCode === 'lk6') {
          next(`/lk6/login?redirect=${to.path}`)
        } else if (siteCode === 'ak2') {
          next(`/ak2/login?redirect=${to.path}`)
        } else if (siteCode === 'mx4') {
          next(`/mx4/login?redirect=${to.path}`)
        } else {
          next(`/login?redirect=${to.path}`)
        }
      }
      // Other pages that do not have menu to access are redirected to the login page.
    }
  }
})

router.afterEach((/* to: RouteLocationNormalized */) => {
  // Finish progress bar
  // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
  NProgress.done()
  // set page title
  // document.title = to.name
})
